import { RouterView } from "vue-router";
import { META_HTML_TITLE } from "@core/constants";
import { ConfirmLeaveComponentFactory } from "@core/components";
import { ETAB_ROUTES, META_MOBILE_NAVIGATION_TABS } from "@etab/config";
import CreateDemandPage from "./CreateDemand.page.vue";
import CreationStep from "./CreationStep.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.creation.root.path,
      name: ETAB_ROUTES.creation.root.name,
      meta: { [META_HTML_TITLE]: "ETAB.PAGES.CREATION.@TITLE" },
      redirect: { name: ETAB_ROUTES.creation.home.name },
      component: RouterView,
      children: [
        {
          path: ETAB_ROUTES.creation.home.path,
          name: ETAB_ROUTES.creation.home.name,
          meta: { [META_MOBILE_NAVIGATION_TABS]: true },
          component: CreateDemandPage,
        },
        {
          path: ETAB_ROUTES.creation.error.path,
          name: ETAB_ROUTES.creation.error.name,
          meta: { [META_MOBILE_NAVIGATION_TABS]: true },
          component: CreateDemandPage,
        },
        {
          path: ETAB_ROUTES.creation.funnel.root.path,
          name: ETAB_ROUTES.creation.funnel.root.name,
          component: ConfirmLeaveComponentFactory.create({
            notGuardedTo: [
              ETAB_ROUTES.creation.error.name,
              ETAB_ROUTES.creationSuccess.name,
              ETAB_ROUTES.subscription.demand.name,
              ETAB_ROUTES.upfront.name,
              ETAB_ROUTES.smartRedirect.name,
            ],
          }),
          redirect: { name: ETAB_ROUTES.creation.funnel.step.name },
          children: [
            {
              path: ETAB_ROUTES.creation.funnel.step.slug.path,
              name: ETAB_ROUTES.creation.funnel.step.slug.name,
              component: CreationStep,
            },
          ],
        },
      ],
    },
  ];
}
